
import { VatDeclarationMonthPeriod } from "@/utils/vat-delcaration/month-period";
import AppMonthSelect from "@/components/common/MonthSelect.vue";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			period: new VatDeclarationMonthPeriod()
		};
	},
	props: {
		show: Boolean
	},
	watch: {
		show: {
			immediate: true,
			handler(){
				if (!this.show) return;
				this.$emit("input", this.period);
			}
		}
	},
	components: {
		AppMonthSelect
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
